import React from "react";

// SCRUM-788: small inline chip rendered next to AI-added/updated bold text,
// carrying the "(added MM/DD/YYYY)" / "(updated MM/DD/YYYY)" tag that
// parseSegmentsWithDateTags (utils/parseBoldMarkers.js) splits out of the
// bold segment. Shared between FreeTextSection and the symptom pill so both
// surfaces render the tag identically.
const DeltaDateTag = ({ dateTag }) => {
  if (!dateTag) return null;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        marginLeft: "4px",
        padding: "1px 6px",
        borderRadius: "8px",
        background: "#EEF2FF",
        color: "#4338CA",
        fontSize: "10px",
        fontWeight: 600,
        fontStyle: "normal",
        whiteSpace: "nowrap",
        verticalAlign: "middle",
      }}
    >
      {dateTag.kind === "updated" ? "updated" : "added"} {dateTag.date}
    </span>
  );
};

export default DeltaDateTag;
